import { Model } from "./model";
import { Testbed } from "./testbed";


export class Storage extends Model {

  totalSpace?: number;

  usage!: number;

  testbed?: Testbed;

  filesCount!: number;

  bucketId?: string;
}
